
import { defineComponent, onBeforeMount, Ref, ref } from "vue";
import { toPercentage } from "../../mixins";

const __default__ = defineComponent({
  props: {
    text: {
      type: String,
      default: "",
    },
    space: {
      type: String,
      default: "",
    },
    alignment: {
      type: String,
      default: "center",
    },
  },
  setup(props) {
    /** Width of the th. */
    const width: Ref<string> = ref("initial");

    onBeforeMount(async () => {
      if (props.space) {
        width.value = `${toPercentage(
          Number(props.space.split("/")[0]),
          Number(props.space.split("/")[1])
        ).toString()}%`;
      }
    });

    return {
      width,
    };
  },
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "0d5004e8": (_ctx.alignment),
  "6780c5ef": (_ctx.width)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__